"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6924],{

/***/ 47669:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50556);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68426);


const useCollaboration = ()=>{
    const isSaksCollaborationEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.features.collaborationSaks);
    if (isSaksCollaborationEnabled) {
        return "saks";
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCollaboration);


/***/ }),

/***/ 66007:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var modules_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7362);

const collaborationCatalogues = {
    saks: {
        all: "SaksAll",
        colognes: "SaksColognes",
        perfumes: "SaksPerfumes",
        unisex: "SaksUnisex"
    }
};
const useCollaborationCatalogueId = (param)=>{
    let { collaboration, catalogueType, skip } = param;
    const collaborationCatalogueName = collaborationCatalogues[collaboration]?.[catalogueType];
    const catalogueId = (0,modules_products__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        catalogueName: collaborationCatalogueName,
        skip: skip || !collaborationCatalogueName
    });
    return catalogueId;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCollaborationCatalogueId);


/***/ }),

/***/ 28724:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var modules_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69219);
/* harmony import */ var _useCollaborationCatalogueId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66007);



const useCollaborationProducts = (props)=>{
    const { catalogueType, collaboration, excludeId, fetchPolicy, limit, productsFeed, skip, filter } = props;
    const { catalogueId, isFetching: isFetchingCatalogueId } = (0,_useCollaborationCatalogueId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        catalogueType,
        collaboration,
        skip
    });
    const { data: rawProducts, isFetching: isFetchingProducts } = (0,modules_products__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        variables: {
            id: catalogueId,
            input: {
                limit: limit ? excludeId ? limit + 1 : limit : null,
                productsFeed,
                filter
            }
        },
        fetchPolicy,
        skip: skip || !catalogueId
    });
    const products = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return rawProducts?.products?.filter((product)=>{
            const { id } = product;
            return id !== excludeId;
        }).slice(0, limit);
    }, [
        excludeId,
        limit,
        rawProducts
    ]);
    return {
        data: products,
        isFetching: isFetchingCatalogueId || isFetchingProducts
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCollaborationProducts);


/***/ }),

/***/ 18219:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50556);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68426);


const getCollaboration = (rebrandLabels)=>{
    if (rebrandLabels?.extra?.includes("SAKS_SELECTED")) {
        return "saks";
    }
};
const useProductCollaboration = (param)=>{
    let { labels } = param;
    const isSaksCollaborationEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.features.collaborationSaks);
    const collaboration = getCollaboration(labels);
    if (collaboration === "saks" && isSaksCollaborationEnabled) {
        return collaboration;
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useProductCollaboration);


/***/ }),

/***/ 52170:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ collaborations_useProductCollaborationLabel)
});

// EXTERNAL MODULE: ./src/modules/collaborations/useProductCollaboration.ts
var useProductCollaboration = __webpack_require__(18219);
;// CONCATENATED MODULE: ./src/modules/collaborations/messages.ts
/* harmony default export */ const messages = ({
    default: {
        en: "Scentbird Select"
    }
});

;// CONCATENATED MODULE: ./src/modules/collaborations/useProductCollaborationLabel.ts


const useProductCollaborationLabel = (param)=>{
    let { labels } = param;
    const collaboration = (0,useProductCollaboration/* default */.Z)({
        labels
    });
    if (collaboration === "saks") {
        return messages["default"];
    }
};
/* harmony default export */ const collaborations_useProductCollaborationLabel = (useProductCollaborationLabel);


/***/ })

}]);